export const SELECT_MARKER = 'SELECT_MARKER';

export const selectMarker = marker => ({
	type: SELECT_MARKER,
	payload: marker
});
